import { decodeRule } from 'vet-bones/utils/queryBuilder';

import { ModelRule } from 'src/containers/ProjectDiagram/types/data';
import { ModelRulesBindingResult } from 'src/templates/queries/modelRules';

export const parseModelRuleResults = (results: ModelRulesBindingResult[]) => {
  const rules: Record<string, ModelRule> = {};
  results.forEach((result: ModelRulesBindingResult) => {
    const { iri, ruleLabel, ruleContent, designerRuleContent, ruleData } =
      result;
    // check that the rule has not been edited outside of designer
    if (ruleContent.value === designerRuleContent.value) {
      const decodedRule = decodeRule(ruleData.value);
      if (decodedRule?.length === 2) {
        rules[iri.value] = {
          id: iri.value,
          name: ruleLabel.value,
          ifClause: decodedRule[0],
          thenClause: decodedRule[1],
        };
      }
    }
  });

  return rules;
};
